<template>
  <menu-items
    v-if="items"
    :items="items"
    :parentID="null"
    :onExpandMenu="handleGetData"
    :onShowMore="handleShowMore"
    :count="actualCount"
    :total="total"
  />
</template>
<script>
  import { mapState } from 'vuex'  
  import axios from 'axios'
  import MenuItems from './MenuItems'
  export default {
    name: 'Dfiles',
    components: {
      // [Vue warn]: Unknown custom element:  did you register the component correctly? For recursive components, make sure to provide the "name" option
      // https://stackoverflow.com/questions/49154490/did-you-register-the-component-correctly-for-recursive-components-make-sure-to
      Items: () => import('@/components/Items'),
      MenuItems
    },
    props: {
      data: {
        type: Object,
        required: true,
        default: null
      },
    },
    data () {
      return {
        items: null,
        loading: false,
        actualCount: null,
        startIndex: 0,
        total: 0
      }
    },
    computed: {
      ...mapState('app',['locale']),
      dfileWorkspace () {
        return this.$store.state.app.dfileWorkspace
      },
    },
    watch: {
      '$store.state.app.authData' () {
        // si se loguea el usuario recargamos los datos
        this.items = null
        this.handleGetData()
      }
    },
    mounted () {
      this.handleGetData()
    },
    methods: {
      prepareUrl (type, id, startIndex) {
        let router = ''

        if (!this.$session.get('dfilesResponse')) router = 'public/folders'
        else router = 'external/customers'

        let url = '' 
        // TODO: montar la URL de todas las llamadas a la API de este componente
        if (type === 'folder') {
          url += `${process.env.VUE_APP_API_URL_DFILES}/${router}/folders/${id}`
          if (!this.$session.get('dfilesResponse')) url += `?workspace=${this.dfileWorkspace}`
          else url += `?token=${this.$session.get('dfilesResponse')}`
          url += `&start_index=${startIndex}`
          url += `&item_per_page=5&search_value=`
          // return `${process.env.VUE_APP_API_URL_DFILES}/external/customers/folders/${id ? id : ''}?token=${this.$session.get('dfilesResponse')}&start_index=${item ? item.startIndex : this.startIndex}&item_per_page=5&search_value=${searchValue}`
        } else {
          url += `${process.env.VUE_APP_API_URL_DFILES}/${router}/files/${id}`
          //url += `?token=${this.$session.get('dfilesResponse')}`
          if (!this.$session.get('dfilesResponse')) url += `?workspace=${this.dfileWorkspace}`
          else url += `?token=${this.$session.get('dfilesResponse')}`
          url += `&start_index=${startIndex}`
          url += `&item_per_page=5`
          url += `&search_value=`
// ${process.env.VUE_APP_API_URL_DFILES}/external/customers/files/${id ? id : ''}?token=${this.$session.get('dfilesResponse')}&start_index=${item.startIndex}&item_per_page=5&search_value=${searchValue}
        }
        return url
      },
      handleShowMore(v) {
        if (v) v.startIndex += 5
        else this.startIndex += 5
        this.handleGetData(v)
      },
      handleGetData(item) {
        if (!item && !this.$session.get('dfilesResponse')) { // get only public folder
          this.handleGetFolders(item)
        } else if (!item || item.type === 'folder')
          if (item && item.CountFile > 0) {
            this.handleGetFiles(item)
          } else {
            this.handleGetFolders(item)          
          }
        else alert('file')
      },
      handleGetFolders (item) {
        this.loading = true
        const id = item ? item.ID : null

        const searchValue = ''
        // axios.get(`${process.env.VUE_APP_API_URL_DFILES}/external/customers/folders/${id ? id : ''}?token=${this.$session.get('dfilesResponse')}&start_index=${item ? item.startIndex : this.startIndex}&item_per_page=5&search_value=${searchValue}`)
        axios.get(this.prepareUrl('folder', id ? id : '', item ? item.startIndex : this.startIndex))
          .then(response => {
            if (!this.items) this.items = []
            const aux = response.data.data.map (item => {
              item.actualCount = null
              item.startIndex = 0
              return item
            })
            this.items.push(...aux)
            if (item) item.actualCount = this.items.filter(x => x.ParentFolderID === item.ID).length
            else {
              this.actualCount = this.items.filter(x => x.ParentFolderID === null).length
              this.total = response.data.count
            }
          })
          // .catch(error => {
          //   console.log('error', error)
          // })
          .finally(() => {
            this.loading = false
          })
      },
      handleGetFiles (item) {
        this.loading = true
        const id = item ? item.ID : null
        const searchValue = ''
         // axios.get(`${process.env.VUE_APP_API_URL_DFILES}/external/customers/files/${id ? id : ''}?token=${this.$session.get('dfilesResponse')}&start_index=${item.startIndex}&item_per_page=5&search_value=${searchValue}`)
        axios.get(this.prepareUrl('file', id ? id : '', item.startIndex))
          .then(response => {
            if (!this.items) this.items = []
            this.items.push(...response.data.data)
            item.actualCount = this.items.filter(x => x.ParentFolderID === item.ID).length
          })
          // .catch(error => {
          //   console.log('jhm', error)
          // })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
</script>
